import styled from '@emotion/styled';
import { motion } from 'framer-motion';


const BaseContainer = styled.div(`
  position: relative;
`
);

export const CardContainer = styled(BaseContainer)(
  ({ theme }) => `
    ${theme.fn.smallerThan(320 + theme.spacing.md * 2)} {
      width: fit-content;
    },
  `
);

export const CardGrid = styled(motion.div)`
  overflow: visible;
  width: 100%;
  display: grid;
  align-items: stretch;
  justify-content: start;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 16px;

  ${({ theme }) => theme.fn.smallerThan('sm')} {
    grid-template-columns: 1fr;
    gap: ${({ theme }) => `${theme.other.layout.paddingSm}px`};
  }
`;
